import React, {useRef, useState} from 'react';
import {usePdf} from '@mikecousins/react-pdf';
import styles from './Pdf.module.css';
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";

const MyPdfViewer = (props: { file: any; }) => {
    let {file} = props;
    let finalFile = file.file;

    const [page, setPage] = useState(1);
    const canvasRef = useRef(null);
    const {pdfDocument} = usePdf({
        file: finalFile,
        page,
        canvasRef,
        scale: 1.5
    });

    if (pdfDocument === undefined) return null;

    return (
        <div className={styles.pdfGrid}>
            {!pdfDocument && <span>Loading...</span>}
            <div className={styles.pdfCanvas}>
                <canvas ref={canvasRef}/>
            </div>
            <div className={styles.pdfButton}>

                {Boolean(pdfDocument && pdfDocument.numPages) && (
                    <>
                        <CustomButton onClick={() => setPage(page - 1)} disabled={page === 1}
                                      children={"Pagina precedente"}/>
                        {page} / {pdfDocument.numPages}
                        <CustomButton onClick={() => setPage(page + 1)} disabled={page === pdfDocument.numPages}
                                      children={"Prossima pagina"}/>
                    </>
                )}
                <br/>
                {Boolean(pdfDocument && pdfDocument.numPages) && (
                    <div className={styles.pdfDownload}>
                        <a download={"EBLCraft-TOS.pdf"} href={finalFile}>
                            <CustomButton children={"Scarica File"}/>
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}

export default MyPdfViewer;
